import React, { useState } from "react";

import line from "../assets/line.png";

import Image1 from "../assets/1.jpg";
import Image2 from "../assets/2.jpg";
import Image4 from "../assets/4.jpg";
import Image5 from "../assets/5.jpg";
import Image6 from "../assets/6.jpg";
import Image7 from "../assets/7.jpg";

export default function GalleryThumb() {
  let data = [
    {
      imgSrc: Image1,
    },
    {
      imgSrc: Image2,
    },
    {
      imgSrc: Image6,
    },
    {
      imgSrc: Image5,
    },
    {
      imgSrc: Image4,
    },
    {
      imgSrc: Image7,
    },
  ];

  const [modal, setModal] = useState(false);
  const [tempImgSrc, setTempImgSrc] = useState("");

  const getImg = (imgSrc) => {
    console.warn(imgSrc);
    setTempImgSrc(imgSrc);
    setModal(true);
  };

  return (
    <>
      <div className={modal ? "modal open" : "modal"}>
        <img src={tempImgSrc} />
        <i
          className="fas fa-times"
          style={{ color: "white" }}
          onClick={() => setModal(false)}
        ></i>
      </div>
      <div className="container-content" style={{ padding: "30px 10px" }}>
        <p
          className="playball-font"
          style={{ fontSize: 25, color: "black", margin: "10px 0px 5px" }}
        >
          Sekilas Cerita Kita
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: 1,
              width: 30,
              backgroundColor: "#cc9933",
              marginTop: 10,
            }}
          />
          <p
            className="dancing-font"
            style={{
              fontSize: 18,
              color: "#cc9933",
              margin: "0px 12px 5px",
            }}
          >
            a glimpse of our story.
          </p>
        </div>

        {/* HERE MAP THE PIC */}
        <div className="gallery">
          {data.map((item, index) => (
            <div className="pics" key={index}>
              <img
                src={item.imgSrc}
                style={{ width: "100%", borderRadius: 15 }}
                onClick={() => getImg(item.imgSrc)}
              />
            </div>
          ))}
        </div>
        <img src={line} width={180} />
      </div>
    </>
  );
}
